import React from 'react';
import { Toolbar, Theme, ToolbarProps, makeStyles } from '@material-ui/core';

export const ToolbarStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            height: 32,
            minHeight: 32,
            border: 'none',
            paddingLeft: 16,
            padding: 0,
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            borderRightColor: theme.tablerow.border,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: theme.tablerow.border,
            backgroundColor: theme.tablerow.secondary
        },
        highlight: {
            height: 32,
            minHeight: 32,
            border: 'none',
            paddingLeft: 16,
            padding: 0,
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            borderRightColor: theme.tablerow.border,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: theme.tablerow.border,
            backgroundColor: theme.palette.primary.main
        }
    }
});


interface IPasslyToolbarProps extends ToolbarProps {
    numberselected: number;
}


export function PasslyTableToolbar(props: IPasslyToolbarProps) {
    const classes = ToolbarStyles();

    return (
        <Toolbar classes={{ root: props.numberselected > 0 ? classes.highlight : classes.root }} {...props} />
    );
}
